var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.147,
    height: 14.5,
    viewBox: "0 0 20.147 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(-1.83 -10.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9263",
    "data-name": "Path 9263",
    d: "M18.936,24.68H4.871A2.794,2.794,0,0,1,2.08,21.889V13.471A2.794,2.794,0,0,1,4.871,10.68H18.936a2.794,2.794,0,0,1,2.791,2.791v8.418a2.794,2.794,0,0,1-2.791,2.791ZM4.871,11.665a1.806,1.806,0,0,0-1.806,1.806v8.418A1.806,1.806,0,0,0,4.871,23.7H18.936a1.806,1.806,0,0,0,1.806-1.806V13.471a1.806,1.806,0,0,0-1.806-1.806Z",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9264",
    "data-name": "Path 9264",
    d: "M12.442,23.238a2.794,2.794,0,0,1-1.684-.561l-7.667-5.8a.492.492,0,1,1,.594-.785l7.667,5.8a1.822,1.822,0,0,0,2.18,0l7.667-5.8a.492.492,0,1,1,.594.785l-7.667,5.8a2.794,2.794,0,0,1-1.684.561Z",
    transform: "translate(-0.538 -3.561)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9265",
    "data-name": "Path 9265",
    d: "M3.161,36.1a.492.492,0,0,1-.328-.86l6.041-5.388a.493.493,0,1,1,.657.735L3.489,35.977a.479.479,0,0,1-.328.125Zm18.275,0a.479.479,0,0,1-.328-.125l-6.041-5.388a.493.493,0,1,1,.657-.735l6.038,5.388a.492.492,0,0,1-.328.86Z",
    transform: "translate(-0.395 -12.794)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.abac991d5d82c3d2779f2c0530c85c46.svg";
export { ForwardRef as ReactComponent };